<template>
  <div>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="queryData">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" prop="序号"></el-table-column>
          <el-table-column prop="DP_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="COUNT" label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.COUNT"></el-input>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button type="text" @click="submitAdd(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      departmentList: [],
      pickerOptions: [],
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '12003',
        OTYPE: 9,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitAdd(row) {
      const params = {
        SERVICE_ID: '10030',
        OTYPE: 11,
        CKS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: sessionStorage.getItem('produceId'),
        PRODUCT_CODE: row.DP_CODE,
        PRODUCT_COUNT: row.COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '添加成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/productionProcessing/addProProduct.vue